export default __webpack_public_path__ + "static/media/correct-icon.5720c7ec.svg";